import React from 'react';

import Company from './Company';
import Accordion from '../../components/Accordion';

const TodayPageOpeningHours = () => {
  const { places } = drupalSettings;

  const currentTimeHours = new Date().getHours();
  const currentTimeMinutes = new Date().getMinutes();

  async function getCompanyList(companies) {
    const fetchOpeningHours = companies.map((company) =>
      getCompanyInfo(company.nid),
    );
    const companyInfo = await Promise.all(fetchOpeningHours);

    const companyListing = companies.map((company, i) => {
      if (
        companyInfo &&
        companyInfo[i].status === 'OK' &&
        companyInfo[i].data.opening_hours
      ) {
        const openingHours = JSON.parse(companyInfo[i].data.opening_hours);
        // Check if the first day returned is actually today
        // Ref: https://jira.exove.net/browse/RMJ-2156
        const firstDayOpeningHours = Object.keys(openingHours)[0];
        const today = new Date().toISOString().split('T')[0];
        if (today !== firstDayOpeningHours) {
          return null;
        }

        const todaysOpeningHours = Object.values(openingHours)[0];

        if (!todaysOpeningHours || !todaysOpeningHours.close) {
          return null;
        }

        let closingTimeHours = parseInt(
          todaysOpeningHours.close.substring(0, 2),
        );
        const closingTimeMinutes = parseInt(
          todaysOpeningHours.close.substring(2, 4),
        );

        // We are not interested in closing times between 00 and 06
        // because after midnight we get the new day's hours.
        if (closingTimeHours <= 6 || closingTimeHours === 0) {
          // 0 means 24
          closingTimeHours = 24;
        }
        if (
          closingTimeHours < currentTimeHours ||
          (closingTimeHours === currentTimeHours &&
            closingTimeMinutes <= currentTimeMinutes)
        ) {
          // Closed already
          return null;
        }

        return {
          title: company.title,
          openingHours: todaysOpeningHours,
        };
      }
    });

    return companyListing
      .filter((company) => company && company !== undefined)
      .sort((a, b) => (a.openingHours.open > b.openingHours.open ? 1 : -1));
  }

  async function getCompanyInfo(nid) {
    const response = await fetch(
      `/${drupalSettings.current_language}/api/opening_hours/${nid}`,
    );

    if (response.ok) {
      const data = await response.json();
      return {
        data,
        status: 'OK',
      };
    } else {
      return { status: 'request failed' };
    }
  }

  async function getCompanies() {
    if (!places) {
      return <p>{Drupal.t('No opening hours to display.')}</p>;
    }

    const companyList = await getCompanyList(places);
    if (companyList) {
      const content = (
        <ul className="today-page__list">
          {companyList &&
            companyList.length > 0 &&
            companyList.map((company, i) => (
              <li key={i} className="today-page-list__item">
                <Company
                  title={company.title}
                  openingHours={company.openingHours}
                />
              </li>
            ))}
        </ul>
      );
      return content;
    } else {
      return <p>{Drupal.t('No opening hours to display.')}</p>;
    }
  }

  return (
    <div className="today-page today-page-opening-hours">
      <h3>{Drupal.t('Opening hours')}</h3>

      <div className="accordion-list">
        <div className="accordion-list__item">
          <Accordion
            fetchContent={getCompanies}
            title={<h4>{Drupal.t('Show opening hours')}</h4>}
          />
        </div>
      </div>
    </div>
  );
};

export default TodayPageOpeningHours;
